"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAdermaHackObject = undefined;
var _misc = require("./misc");
var buildAdermaHackObject = exports.buildAdermaHackObject = function buildAdermaHackObject(attendee_type) {
  var addressFieldIdByAttendeeTypeId = {
    "38988": 450573,
    "38989": 450582,
    "35477": 449190,
    "35478": 449192,
    "35479": 449194,
    "35482": 449195,
    "35483": 449198,
    "35484": 449200,
    "37532": 449202,
    "35485": 449204,
    "37533": 449205,
    "35486": 449206,
    "37534": 449207,
    "35487": 449208,
    "37535": 449209,
    "35488": 449210,
    "37536": 449211,
    "37537": 449212,
    "35490": 449214,
    "37538": 449215,
    "35491": 449216,
    "37539": 449217,
    "35492": 449218,
    "37540": 449219,
    "35493": 449220,
    "37541": 449221,
    "37542": 449222
  };
  var hiddenCodeFieldByAttendeeTypeId = {
    "38988": 459945,
    "38989": 459946,
    "35477": 459947,
    "35478": 459948,
    "35479": 459949,
    "35482": 459950,
    "35483": 459951,
    "35484": 459952,
    "37532": 459953,
    "35485": 459954,
    "37533": 459955,
    "35486": 459956,
    "37534": 459957,
    "35487": 459958,
    "37535": 459959,
    "35488": 459960,
    "37536": 459961,
    "37537": 459962,
    "35490": 459963,
    "37538": 459964,
    "35491": 459965,
    "37539": 459966,
    "35492": 459967,
    "37540": 459968,
    "35493": 459969,
    "37541": 460167,
    "37542": 460168
  };
  var hackParams = {
    attendee_type: attendee_type,
    initialize_via_params: true
  };
  hackParams["attendee[company]"] = (0, _misc.getQueryParam)("raison");
  hackParams["attendee[custom_fields][" + addressFieldIdByAttendeeTypeId[attendee_type.toString()] + "]"] = (0, _misc.getQueryParam)("address");
  hackParams["attendee[custom_fields][" + hiddenCodeFieldByAttendeeTypeId[attendee_type.toString()] + "]"] = (0, _misc.getQueryParam)("code");
  return hackParams;
};